<div class="loader-overlay" [class.active]="isLoading">
    <div class="loader-backdrop"></div>
    <div class="loader-content">
        <div class="sun-container">
            <div class="sun-core"></div>
            <div class="sun-rays">
                <span style="--i:1"></span>
                <span style="--i:2"></span>
                <span style="--i:3"></span>
                <span style="--i:4"></span>
                <span style="--i:5"></span>
                <span style="--i:6"></span>
                <span style="--i:7"></span>
                <span style="--i:8"></span>
                <span style="--i:9"></span>
                <span style="--i:10"></span>
                <span style="--i:11"></span>
                <span style="--i:12"></span>
            </div>
        </div>
        <div class="loader-text">
            <h1 class="brand-title">Suntur Quri Wasi</h1>
            <p class="loading-message">{{ message }}</p>
            <div class="progress-bar">
                <div class="progress-fill"></div>
            </div>
        </div>
    </div>
</div>